import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContactusService {

  constructor(private http: HttpClient) { }

  private baseUrl: string = environment.apiUrl;

  private static handleError(error: HttpErrorResponse) {
    console.log(error.error.ResponseMessage);

    // return an observable with a user friendly message
    return throwError(`${error.error.ResponseMessage}`);
  }

  addContactUs(Payload) {
    return this.http.post<any>(`${this.baseUrl}/contact/add-contact`, Payload)
      .pipe(map(res => {
        return res;
      }));

  }

  getAllContacts(): Observable<any> {
    return this.http.get(`${this.baseUrl}/contact/get-contacts`).pipe(
      map((res) => {
        return res;
      }),
      catchError(ContactusService.handleError));
  }

  getAllSubscriptions(): Observable<any> {
    return this.http.get(`${this.baseUrl}/contact/get-subscription-list`).pipe(
      map((res) => {
        return res;
      }),
      catchError(ContactusService.handleError));
  }


  addDoctorReview(Payload) {
    return this.http.post<any>(`${this.baseUrl}/contact/add-review`, Payload)
      .pipe(map(res => {
        return res;
      }));

  }

  getDoctorReview(Payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/contact/get-reviews`,Payload).pipe(
      map((res) => {
        return res;
      }),
      catchError(ContactusService.handleError));
  }

  addEnquiry(Payload) {
    return this.http.post<any>(`${this.baseUrl}/contact/add-enquiry`, Payload)
      .pipe(map(res => {
        return res;
      }));

  }

  getAllEnquiry(): Observable<any> {
    return this.http.get(`${this.baseUrl}/contact/get-enquiry`).pipe(
      map((res) => {
        return res;
      }),
      catchError(ContactusService.handleError));
  }

  getCompanyEnquiry(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/contact/get-company-enquiry`,payload).pipe(
      map((res) => {
        return res;
      }),
      catchError(ContactusService.handleError));
  }

  getRecommendationReview(page,size): Observable<any> {
    return this.http.get(`${this.baseUrl}/contact/get-recomendation?offset=${page}&limit=${size}`).pipe(
      map((res) => {
        return res;
      }),
      catchError(ContactusService.handleError));
  }

  getAllSchoolEnquiry(data): Observable<any> {
    return this.http.post(`${this.baseUrl}/contact/get-school-enquiry`,data).pipe(
      map((res) => {
        return res;
      }),
      catchError(ContactusService.handleError));
  }

  getPandemicCareList(): Observable<any> {
    return this.http.get(`${this.baseUrl}/contact/get-pandemic-care`).pipe(
      map((res) => {
        return res;
      }),
      catchError(ContactusService.handleError));
  }

  getPandemicCareDownloadList(): Observable<any> {
    return this.http.get(`${this.baseUrl}/contact/get-pandemic-download`).pipe(
      map((res) => {
        return res;
      }),
      catchError(ContactusService.handleError));
  }

  getNomineeList(): Observable<any> {
    return this.http.get(`${this.baseUrl}/contact/getAllNominee`).pipe(
      map((res) => {
        return res;
      }),
      catchError(ContactusService.handleError));
  }

  getOrganizationPages(): Observable<any> {
    return this.http.get(`${this.baseUrl}/cms/getOrganizationPages`).pipe(
      map((res) => {
        return res;
      }),
      catchError(ContactusService.handleError));
  }

  deleteOrganizationPageById(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/cms/deleteOrganizationPageById`, payload).pipe(
      map((res) => {
        return res;
      }),
      catchError(ContactusService.handleError));
  }
  editOrganizationPage(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/cms/editOrganizationPage`, payload).pipe(
      map((res) => {
        return res;
      }),
      catchError(ContactusService.handleError));
  }
  addOrganizationPage(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/cms/addOrganizationPage`, payload).pipe(
      map((res) => {
        return res;
      }),
      catchError(ContactusService.handleError));
  }


  getOrganizations(): Observable<any> {
    return this.http.get(`${this.baseUrl}/cms/getOrganizations`).pipe(
      map((res) => {
        return res;
      }),
      catchError(ContactusService.handleError));
  }

  getActiveOrgsForRegion(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/cms/getactiveorgsforregion`,payload).pipe(
      map((res) => {
        return res;
      }),
      catchError(ContactusService.handleError));
  }

  deleteOrganizationById(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/cms/deleteOrganizationById`, payload).pipe(
      map((res) => {
        return res;
      }),
      catchError(ContactusService.handleError));
  }
  editOrganization(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/cms/editOrganization`, payload).pipe(
      map((res) => {
        return res;
      }),
      catchError(ContactusService.handleError));
  }
  addOrganization(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/cms/addOrganization`, payload).pipe(
      map((res) => {
        return res;
      }),
      catchError(ContactusService.handleError));
  }
}
